export const MODULE_LABELS: Record<string, string> = {
  holidays: "Vacaciones",
  permissions: "Permisos",
  partners: "Colaboradores",
  "missing-box": "Faltantes",
  documents: "Documentos",
  incidents: "Incidencias",
  admin: "Administración",
};

export const MODULE_ICONS: Record<string, string> = {
  holidays: "fa-solid fa-calendar-days",
  permissions: "fa-solid fa-file-signature",
  partners: "fa-solid fa-user",
  "missing-box": "fa-solid fa-triangle-exclamation",
  documents: "fa-solid fa-file-lines",
  incidents: "fa-solid fa-circle-exclamation",
  admin: "fa-solid fa-bell",
};

/** Clase CSS de tono suave por módulo (tags / iconos). */
export const MODULE_TONES: Record<string, string> = {
  holidays: "holidays",
  permissions: "permissions",
  partners: "partners",
  "missing-box": "missing-box",
  documents: "documents",
  incidents: "incidents",
  admin: "admin",
};

export function getModuleLabel(module?: string | null): string {
  if (!module) return "General";
  return MODULE_LABELS[module] || module;
}

export function getModuleIcon(module?: string | null): string {
  if (!module) return "fa-solid fa-bell";
  return MODULE_ICONS[module] || "fa-solid fa-bell";
}

export function getModuleTone(module?: string | null): string {
  if (!module) return "default";
  return MODULE_TONES[module] || "default";
}

function startOfLocalDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function formatTime(date: Date) {
  return new Intl.DateTimeFormat("es-MX", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

/** Fecha legible para la lista completa. */
export function formatFriendlyDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const today = startOfLocalDay(new Date());
  const target = startOfLocalDay(date);
  const diffDays = Math.round(
    (today.getTime() - target.getTime()) / (24 * 60 * 60 * 1000)
  );
  const time = formatTime(date);

  if (diffDays === 0) return `Hoy, ${time}`;
  if (diffDays === 1) return `Ayer, ${time}`;

  const dayMonth = new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  return `${dayMonth}, ${time}`;
}

/** Fecha corta para el dropdown de la campanita. */
export function formatShortDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const today = startOfLocalDay(new Date());
  const target = startOfLocalDay(date);
  const diffDays = Math.round(
    (today.getTime() - target.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (diffDays === 0) return formatTime(date);
  if (diffDays === 1) return "Ayer";

  return new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "short",
  }).format(date);
}
